import lodash from 'lodash';
import queryString from 'query-string';
const RedirectConfig: Array<ConfigParams> = [
  {
    Page: '登录页',
    PCURL: '/account/',
    PCURLParams: [
      {
        ParamsName: 'loginType',
        ParamsType: 'query',
        MapName: 'login',
      },
      {
        ParamsName: 'appId',
        ParamsType: 'query',
      },
      {
        ParamsName: 'display',
        ParamsType: 'query',
      },
      {
        ParamsName: 'forceLogin',
        ParamsType: 'query',
      },
      {
        ParamsName: 'redirectUrl',
        ParamsType: 'query',
      },
      {
        ParamsName: 'scope',
        ParamsType: 'query',
      },
    ],
    WapURL: '/accountm/',
    WapURLParams: [
      {
        ParamsName: 'login',
        ParamsType: 'query',
        MapName: 'loginType',
      },
      {
        ParamsName: 'omitBusinessType',
        ParamsType: 'query',
        FixedValue: 'true',
      },
      {
        ParamsName: 'appId',
        ParamsType: 'query',
      },
      {
        ParamsName: 'display',
        ParamsType: 'query',
      },
      {
        ParamsName: 'forceLogin',
        ParamsType: 'query',
      },
      {
        ParamsName: 'redirectUrl',
        ParamsType: 'query',
      },
      {
        ParamsName: 'scope',
        ParamsType: 'query',
      },
    ],
  },
];

export const urlTransform = (
  /** 当前url/路由 */
  url: string,
  /** 当前平台 */
  sourcePlatform: Platform,
  /** 目标平台 */
  targetPlatform: Platform,
  /** 外部传入的query参数 */
  query?: object,
  /** 当前页面的asPath，动态路由或微前端路由时需传入 */
  asPath?: string,
) => {
  try {
    // 判断是否是子应用路由
    const matches = url.match(/\[([^\]]+)\]/);
    const isMicroApp = matches && matches[1] == '...all';
    const parseUrlObj = queryString.parseUrl(isMicroApp ? asPath : url);
    // 找到匹配的路由配置
    const config = RedirectConfig.find((item) => {
      const sourcePlatformUrl = item?.[`${sourcePlatform}URL`];
      const sourcePlatformDynamicUrl = item?.[`${sourcePlatform}DynamicUrl`];
      const sourcePlatformUrlParams = item?.[`${sourcePlatform}URLParams`];
      const sourcePlatformExtraUrl = item?.[`${sourcePlatform}ExtraUrl`] || [];

      // 当前url 和 配置中的url或动态路由url匹配
      const urlOrDynamicUrlMatched = lodash.some(
        [
          sourcePlatformUrl,
          sourcePlatformDynamicUrl,
          ...sourcePlatformExtraUrl,
        ],
        (urlToMatch) => {
          return urlToMatch === (parseUrlObj.url || '');
        },
      );

      // 如果URL或动态URL不匹配，直接返回false
      if (!urlOrDynamicUrlMatched) {
        return false;
      }

      // 参数匹配，如果参数配置了MatchedUrlFn，则调用此函数根据返回值判断是否匹配
      // 主要是用于多个页面共用一个路由，单纯靠路由不能准确匹配到配置项，因此需要参数辅助匹配的场景
      let queryMatched = true;
      if (sourcePlatformUrlParams) {
        lodash.forEach(sourcePlatformUrlParams, (paramConfig) => {
          const { MatchedUrlFn } = paramConfig;
          if (MatchedUrlFn && lodash.isFunction(MatchedUrlFn)) {
            queryMatched = MatchedUrlFn(lodash.merge(parseUrlObj.query, query));
          }
        });
      }

      return queryMatched;
    });

    if (!config) {
      return '';
    }

    // 提取动态路由参数和query
    let sourceParams = {};

    // 如果url是包含动态路由参数的字符串，使用正则表达式匹配
    if (matches && !isMicroApp) {
      const parts = asPath?.split('/');
      const lastPart = parts?.[parts.length - 1];
      if (lastPart) {
        lodash.set(sourceParams, matches[1], lastPart);
      }
    }

    // 如果parseUrlObj.query存在，合并到sourceParams中
    if (parseUrlObj.query) {
      lodash.merge(sourceParams, parseUrlObj.query);
    }

    // 如果外部传入的query存在，也合并到sourceParams中
    if (query) {
      lodash.merge(sourceParams, query);
    }

    // 生成目标地址 和 参数的处理
    let targetPath = lodash.get(config, `${targetPlatform}URL`);
    const targetURLParams = lodash.get(config, `${targetPlatform}URLParams`);

    if (targetURLParams) {
      let targetParams = {};
      targetURLParams.forEach((item) => {
        const { FixedValue, MapName, ParamsName, DefaultValue, ParamsType } =
          item;
        let value = FixedValue;
        if (!value) {
          // 从sourceParams中获取值
          value = lodash.get(sourceParams, MapName || ParamsName, DefaultValue);
        }
        if (ParamsType === 'query') {
          lodash.set(targetParams, ParamsName, value);
        } else if (ParamsType === 'params') {
          // 将值添加到路径中
          if (targetPath.endsWith('/')) {
            targetPath += value;
          } else {
            targetPath += '/' + value;
          }
        }
      });

      return queryString.stringifyUrl({
        url: targetPath,
        query: targetParams,
      });
    }

    // 目标地址没有参数，直接返回配置的目标地址
    return targetPath;
  } catch (error) {
    return '';
  }
};

type Platform = 'PC' | 'Wap';

interface Params {
  /** 参数名称 */
  ParamsName: string;
  /** 参数类型（ID/001 or ID=001）params query */
  ParamsType: string;
  /** 默认值，若转换为目标url时没获取到此参数，则使用此默认值 */
  DefaultValue?: string;
  /** 固定值 */
  FixedValue?: string;
  /** 映射名称，若pc和h5的参数名称不一致，做映射*/
  MapName?: string;
  /** 参数匹配函数，用于匹配url，返回true则匹配成功 */
  MatchedUrlFn?: Function;
}

interface ConfigParams {
  /** 页面名称 */
  Page: string;
  /** pc端url */
  PCURL: string;
  /** pc端动态路由 */
  PCDynamicUrl?: string;
  /** pc端url参数 */
  PCURLParams?: Array<Params>;
  /** PC端额外匹配的url，用于一个页面有多个路由可以访问到的场景 */
  PCExtraUrl?: Array<string>;
  /** h5端url */
  WapURL: string;
  /** h5端动态路由 */
  WapDynamicUrl?: string;
  /** h5端额外匹配的url，用于一个页面有多个路由可以访问到的场景 */
  WapExtraUrl?: Array<string>;
  /** h5端url参数 */
  WapURLParams?: Array<Params>;
}
